import { useState, useEffect } from "react";
import UniversalInput from "@/components/FormsElements/UniversalInput";
import MainButton from "@/components/Button/MainButton";
import { Link } from "@/i18n/navigation";
import { useTranslations, useLocale } from "next-intl";
import config from "../../../../config.mjs";
import { formatLocale } from "@/lib/formatLocale.js";


const ResetPasswordPage = () => {
  const t = useTranslations('resetPassword');
  const locale = useLocale();
  const contextCode = formatLocale(locale);
  const [authorEmail, setAuthorEmail] = useState("");

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValidEmail = emailRegex.test(authorEmail.trim());
  const [isButtonDisabled, setIsButtonDisabled] = useState(!isValidEmail);

  const [isEmailError, setIsEmailError] = useState();
  const [isSent, setIsSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { apiBaseUrl } = config;

  useEffect(() => {
    setIsButtonDisabled(!isValidEmail);
  }, [authorEmail])
  async function handleResetPassword() {
    try {
      setIsLoading(true);
      setIsButtonDisabled(true);
      const response = await fetch(apiBaseUrl + '/user/forgot-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: authorEmail, contextCode: contextCode }),

      });

      if (response.ok) {
        const data = await response.json();
        if (data.status === 'reset_link_sent') {
          // console.log('Reset link sent successfully.');
          setIsEmailError(false);
          setIsSent(true);
          // Optionally show a success message to the user
        }
      } else if (response.status === 400) {
        console.error('Validation error or email not found.');
        setIsEmailError(true);
        // Optionally show an error message to the user
      } else {
        console.error('Something went wrong.');
        // Handle other unexpected errors
      }
    } catch (error) {
      console.error('Network error:', error);
      
      // Handle network or server errors
    } finally {
      setIsLoading(false);
      setIsButtonDisabled(false);
  }
    
  }


  return (
    <>
      <div className="w-full  ">
        <h2 className="text-center text-[32px] md:text-[44px] font-bold mb-6">{t('title')}</h2>
        {!isSent && (
          <div className="mt-6 mb-8 px-4 md:px-0 font-medium text-center">
            {t('description')}
          </div>
        )}

        <div className="px-4">
          <div className="pb-9">
            {
              !isSent && (
                <UniversalInput
                  type="email"
                  placeholder={t('emailPlaceholder')}
                  label={t('emailLabel')}
                  value={authorEmail}
                  onChange={setAuthorEmail}
                  extraLabel={true}
                  border={true}
                  setIsButtonDisabled={setIsButtonDisabled}
                />
              )
            }
            {
              isSent && (
                <p className="text-[#2B2B2B] text-[18px] mt-1 text-center">{t('successMessage')}</p>
              )
            }

            {
              !isSent && (
                <div className="mt-10 md:mt-12">

                  <MainButton
                    text={t('sendResetLink')}
                    disabled={isButtonDisabled}
                    fontSize="20px"
                    onClick={handleResetPassword}
                    isLoading={isLoading}
                  />

                </div>
              )
            }

          </div>

          <div className="mt-4 md:mt-12 pt-4 md:pb-6 pb-0">

          </div>
        </div>

      </div>

      <div className="w-full flex justify-center text-[15px] gap-2 ">
        <div className="italic text-black font-medium">{t('needHelp')}</div>
        <Link href="/contact-us">
          <div className="text-[#006FFF] underline">{t('contactSupport')}</div>
        </Link>
      </div>
    </>
  );
};

export default ResetPasswordPage;
